import React from 'react';
import AppContainer from '@src/containers/App';

const App = () => <AppContainer />;

export default App;
